module.exports = __webpack_public_path__ + "img/SHIPPING.2990aacb.svg";